'use strict'

export default {
  grid (root) {
    return {
      id: (new Date()).getTime(),
      isAutoLoad: true, // auto load data of grid
      mode: {
        isPreviewMode: false, // hide => controls, inline edit
        isInner: false,

        isModalEditing: false,
        isModalNew: false,
        isModalPush: false // Is add a new record to browser history when modal is open
      },
      store: {
        get: {
          url: null, // String => 'Certs/GetAllDynamic'
          selected: null, // String | Array => 'id,title' | ['id', 'title']
          filters: null, // String => 'field == "sdsd"'
          expand: null, // Boolean
          parser: null, // Function of parse data
          orderBy: { // Using if does not using a sort by columns
            field: null, // column field
            order: null // string asc || desc
          }
        },
        create: {
          url: null
        },
        patch: {
          url: null,
          method: 'patch'
        },
        delete: {
          url: null,
          modal: {
            msgTemplate: null,
            msgDataKey: 'title'
          }
        },
        mainField: 'id',
        rowFieldKey: null
      },
      columns: [],
      rowControls: {
        left: {
          isFixed: true,
          classes: null,
          styles: null,
          controls: []
        },
        right: {
          isFixed: true,
          classes: null,
          styles: null,
          controls: []
        }
      },
      itemParser: null,
      header: {
        isVisible: true,
        position: 'outside', // position the header relative to grid warp (outside and inside)
        title: {
          isVisible: true,
          value: null
        },
        controls: {
          isVisible: true,
          isRefresh: true,
          export: {
            isVisible: true,
            permission: null,
            excel: {
              permission: 'isAllowToExportExcel',
              current: {
                isVisible: true,
                titleFile: '',
                wbName: '',
                titleBtn: root.L10n('current-page')
              },
              all: {
                isVisible: true,
                titleFile: '',
                wbName: '',
                titleBtn: root.L10n('all-page')
              }
            },
            json: {
              current: {
                isVisible: true,
                title: '',
                titleBtn: root.L10n('current-page')
              },
              all: {
                isVisible: true,
                title: '',
                titleBtn: root.L10n('all-page')
              }
            }
          },
          addNew: {
            isVisible: true,
            title: root.L10n('add-new'),
            permission: null
          }
        }
      },
      breadcrumb: {
        isVisible: true
      },
      toolbar: {
        isVisible: true,
        filters: []
      },
      sortable: { // init sort
        field: null, // column field
        order: null // string asc || desc
      },
      pagination: {
        isVisible: true,
        current: 1,
        total: 0,
        size: 25,
        sizes: {
          isVisible: true,
          values: [
            {
              label: '10',
              value: 10
            },
            {
              label: '15',
              value: 15
            },
            {
              label: '25',
              value: 25
            },
            {
              label: '50',
              value: 50
            },
            {
              label: '100',
              value: 100
            }
          ]
        }
      },
      permission: {
        edit: null // String => INLINE EDIT, example: 'isAllowEdit'
      }
    }
  },
  gridControls (Name, root) {
    if (!Name) return new Error('Error parse GRID controls')
    switch (Name) {
      case 'edit': {
        return {
          type: 'edit',
          title: root.L10n('details'),
          isVisible: true, // Boolean or expression
          permission: null,
          template: null,
          disabled: false,
          classes: null,
          styles: null,
          buttonClass: '' // string or function
        }
      }
      case 'view': {
        return {
          type: 'view',
          title: root.L10n('view'),
          isVisible: true, // Boolean or expression
          permission: null,
          template: null,
          disabled: false,
          classes: null,
          styles: null,
          buttonClass: '' // string or function
        }
      }
      case 'clone': {
        return {
          type: 'clone',
          title: root.L10n('clone'),
          isVisible: true, // Boolean or expression
          template: null,
          disabled: false,
          classes: null,
          styles: null,
          buttonClass: '' // string or function
        }
      }
      case 'delete': {
        return {
          type: 'delete',
          isVisible: true, // Boolean or expression
          title: root.L10n('delete'),
          permission: null,
          template: null,
          disabled: false,
          classes: '',
          styles: '',
          buttonClass: '' // string or function
        }
      }
      default :
        return {
          type: 'custom',
          action: 'CUSTOM',
          isVisible: true, // Boolean or expression
          title: '',
          permission: null,
          template: null,
          disabled: false,
          classes: '',
          styles: '',
          buttonClass: '' // string or function
        }
    }
  },
  gridColumn () {
    return {
      title: null,
      field: null,
      permission: null,
      sortable: {
        isAvailable: true,
        custom: { // or String custom field
          asc: null, // string || function
          desc: null // string || function
        }
      },
      template: null,
      isFixed: false,
      export: {
        excel: this.gridColumnExcel(),
        json: this.gridColumnJson(),
        print: {
          isExport: true,
          width: null,
          style: null,
          template: null
        }
      },
      th: {
        classes: '',
        styles: ''
      },
      td: {
        classes: '',
        styles: ''
      },
      classes: '',
      styles: '',
      filter: null,
      editor: null
    }
  },
  gridColumnFilter () {
    return {
      id: this.getID(),
      removeSkip: true,
      type: '',
      field: '',
      options: null,
      permission: null,
      place: null
    }
  },
  gridColumnJson () {
    return {
      isExport: true,
      field: '',
      template: null
    }
  },
  gridColumnExcel () {
    return {
      isExport: true,
      title: '',
      field: '',
      width: 15,
      type: 's',
      style: {},
      template: null
    }
  },
  getID () {
    return `random_${_.random(0, 1000000)}`
  }
}
